/** Short text for the play page. The raw chain error is logged, not shown. */
export function readableChainError(raw: string): string {
  let text = raw;
  try {
    text = decodeURIComponent(raw);
  } catch {
    text = raw;
  }
  console.error(text);
  if (/insufficient lamports|custom program error: 0x1\b/i.test(text)) {
    return "The game account does not have enough custody-chain SOL yet. Wait a minute and try again.";
  }
  if (text.length > 180) return "The transaction failed. The details are in the browser console.";
  return text;
}
